var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-3 pr-5",staticStyle:{"background-color":"#f8f9fa"}},[_c('Sidebar')],1),_c('div',{staticClass:"col-md-9 pr-2 pl-2"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }